import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

import DynamicDataGrid from '../common/DynamicDataGrid/DynamicDataGrid';
import { numberWithCommas } from '../../util/CommonUtils';
import FunctionBoxButtonGroupV2 from './FunctionBoxButtonGroupV2';

const commaFormatter = ({ value }) => <div>{numberWithCommas(value)}</div>;

commaFormatter.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

class FunctionBoxAverageV2 extends Component {
  static getColumns() {
    return [
      { key: 'description', name: 'Description', sortable: true, width: 150 },
      { key: 'keyword', name: 'Keyword', sortable: true, width: 150 },
      {
        key: 'midpoint',
        name: 'Midpoint',
        sortable: true,
        editable: true,
        width: 150,
      },
      {
        key: 'weight',
        name: 'Weight',
        sortable: true,
        width: 150,
        formatter: commaFormatter,
      },
      {
        key: 'total',
        name: 'Total',
        sortable: true,
        width: 100,
        formatter: commaFormatter,
      },
    ];
  }

  constructor(props) {
    super(props);
    this.state = {
      isMedian: false,
      isDiscrete: false,
      excludeZero: true,
      rowsData: this.props.sampleWeightedValues
        ? this.getRowsData(this.props.sampleWeightedValues)
        : [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.sampleWeightedValues &&
      this.props.sampleWeightedValues !== nextProps.sampleWeightedValues
    ) {
      this.setState({
        rowsData: this.getRowsData(nextProps.sampleWeightedValues),
      });
    }
  }

  getRowsData = sampleWeightedValues => {
    if (sampleWeightedValues.length > 0) {
      return this.props.selectedTargets.map((item, index) => ({
        description: item.shortText,
        keyword: item.keyword,
        midpoint: item.midpoint ? item.midpoint : 0,
        weight: sampleWeightedValues[index].weighted,
        total: item.midpoint
          ? item.midpoint * sampleWeightedValues[index].weighted
          : 0,
      }));
    }

    return [];
  };

  handleMeanMedian = isMedian => this.setState({ isMedian });

  handleContinuousDiscrete = isDiscrete => this.setState({ isDiscrete });

  createExpression = () => {
    let expressionKeyword = '';
    if (!this.state.isMedian) {
      expressionKeyword = this.state.excludeZero
        ? 'MEANSCORENOZERO ('
        : 'MEANSCORE ( ';
    } else if (!this.state.isDiscrete) {
      expressionKeyword = this.state.excludeZero
        ? 'MEDIANNOZERO ( VOLUME ( '
        : 'MEDIAN ( VOLUME ( ';
    } else {
      expressionKeyword = this.state.excludeZero
        ? 'MEDIANDISCRETENOZERO ( VOLUME ( '
        : 'MEDIANDISCRETE ( VOLUME ( ';
    }

    expressionKeyword = this.state.rowsData.reduce(
      (acc, item) => `${acc} ${item.keyword} , ${item.midpoint} , `,
      expressionKeyword,
    );

    expressionKeyword = expressionKeyword.slice(0, -2);

    if (!this.state.isMedian) {
      expressionKeyword = `${expressionKeyword} )`;
    } else {
      expressionKeyword = `${expressionKeyword} ) )`;
    }

    return expressionKeyword;
  };

  createSmartSearchArray = () => {
    const selectedTargets = _.cloneDeep(this.props.selectedTargets);
    const objSmartSearchArray = {};
    const objectsAdded = [];
    const expressionFormed = [];
    const tags = [];

    selectedTargets.forEach(target => {
      const breadcrumbList = JSON.parse(window.localStorage.getItem('breadCrumb'));
      const breadCrumbValue = breadcrumbList ? breadcrumbList.reverse().join(' > ') : undefined;

      target.breadcrumbs = breadCrumbValue;
      objectsAdded.push(target);
      expressionFormed.push(target.keyword);
      tags.push(target.shortText);
    });
    objSmartSearchArray.objectsAdded = objectsAdded;
    objSmartSearchArray.expressionFormed = expressionFormed;
    objSmartSearchArray.tags = tags;

    return objSmartSearchArray;
  }

  moveAppendToCodingBox = isMove =>
    this.props.moveAppendToCodingBox(isMove, this.createExpression(), this.createSmartSearchArray());

  moveToColumns = () => {
    if (this.props.functionTitle) {
      this.props.moveToColumns(this.createExpression(), this.createSmartSearchArray());
    } else {
      this.props.moveToColumns();
    }
  };

  moveToRows = () => {
    if (this.props.functionTitle) {
      this.props.moveToRows(this.createExpression(), this.createSmartSearchArray());
    } else {
      this.props.moveToRows();
    }
  };

  addToDefinitionModal = () => {
    if (this.props.functionTitle) {
      this.props.addToDefinition(this.createExpression());
    } else {
      this.props.addToDefinition();
    }
  };

  handleDataUpdate = (gridRows, rowNumber, { midpoint }) => {
    const formattedMidPoint = midpoint !== '' ? midpoint : 0;
    const rowsData = gridRows;
    const updatedRow = {
      ...gridRows[rowNumber],
      total: (midpoint * gridRows[rowNumber].weight).toFixed(),
      midpoint: formattedMidPoint,
    };
    Object.assign(rowsData[rowNumber], updatedRow);
    this.setState({ rowsData });
  };

  render() {
    return (
      <div className="function-box-average">
        <div className="row expanded">
          <div className="small-12 medium-8 large-9 columns padding-left-0">
            <DynamicDataGrid
              gridCategory="FunctionBoxGrid"
              className="saved-crosstab-grid"
              gridHeight={320}
              gridWidth={700}
              rows={this.state.rowsData}
              columns={this.constructor.getColumns()}
              rowSelectionType="Single"
              isCellSelectable
              minimunRows={8}
              onDataUpdate={this.handleDataUpdate}
            />
          </div>
          <div className="small-12 medium-3 large-3 columns function-position">
            <div className="text-left">
              <input
                type="radio"
                name="Mean"
                id="Mean"
                onChange={() => this.handleMeanMedian(false)}
                checked={!this.state.isMedian}
              />
              <label htmlFor="Mean">Mean</label>
            </div>
            <div className="text-left">
              <input
                type="radio"
                name="Median"
                id="Median"
                onChange={() => this.handleMeanMedian(true)}
                checked={this.state.isMedian}
              />
              <label htmlFor="Median">Median</label>
            </div>
            <div className="text-left margin-bottom-10">
              <input
                id="exclude-zeros-checkbox"
                type="checkbox"
                onChange={() =>
                  this.setState({ excludeZero: !this.state.excludeZero })
                }
                checked={this.state.excludeZero}
              />
              <label
                htmlFor="exclude-zeros-checkbox"
                className="margin-right-0"
              >
                Exclude Zeros
              </label>
            </div>
            <div
              className=""
              style={{ display: this.state.isMedian ? 'block' : 'none' }}
            >
              <div className="small-6 columns padding-left-0">
                <input
                  type="radio"
                  name="Continuous"
                  id="Continuous"
                  onChange={() => this.handleContinuousDiscrete(false)}
                  checked={!this.state.isDiscrete}
                />
                <label htmlFor="Continuous">Continuous</label>
              </div>
              <div className="small-6 columns padding-right-0">
                <input
                  type="radio"
                  name="Discrete"
                  id="Discrete"
                  onChange={() => this.handleContinuousDiscrete(true)}
                  checked={this.state.isDiscrete}
                />
                <label htmlFor="Discrete">Discrete</label>
              </div>
            </div>
            <div className="clearfix margin-top-10">
              <FunctionBoxButtonGroupV2
                moveAppendToCodingBox={this.moveAppendToCodingBox}
                moveToColumns={this.moveToColumns}
                moveToRows={this.moveToRows}
                addToDefinitionModal={this.addToDefinitionModal}
                noExpressionBox={this.props.noExpressionBox}
                noCRB={this.props.noCRB}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

FunctionBoxAverageV2.propTypes = {
  functionTitle: PropTypes.string,
  moveAppendToCodingBox: PropTypes.func,
  moveToRows: PropTypes.func,
  moveToColumns: PropTypes.func,
  addToDefinition: PropTypes.func,
  sampleWeightedValues: PropTypes.arrayOf(PropTypes.object),
  selectedTargets: PropTypes.arrayOf(PropTypes.object),
  noExpressionBox: PropTypes.bool,
  noCRB: PropTypes.bool,
};


export default FunctionBoxAverageV2;
